/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enterprice1Inputs */

const en_enterprice1 = /** @type {(inputs: Enterprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter price`)
};

const de_enterprice1 = /** @type {(inputs: Enterprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis eingeben`)
};

/**
* | output |
* | --- |
* | "Enter price" |
*
* @param {Enterprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const enterprice1 = /** @type {((inputs?: Enterprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enterprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enterprice1(inputs)
	return de_enterprice1(inputs)
});
export { enterprice1 as "enterPrice" }